import { gql } from '@apollo/client';

export const NOTIFICATION_FIELDS_FRAGMENT = gql`
  fragment NotificationFields on Notification {
    _id
    group
    message
    severity
    params {
      name
      value
    }
    createdAt
    createdBy
  }
`;

export const GET_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}
  query notifications($orderBy: [NotificationOrderByExp!], $where: NotificationBoolExp!) {
    notifications(order_by: $orderBy, where: $where) {
      ...NotificationFields
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation insertOneNotification($data: NotificationInsertInput!) {
    result: insertOneNotification(data: $data) {
      value {
        _id
      }
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation deleteOneNotification($query: NotificationQueryInput!) {
    deleteOneNotification(query: $query) {
      deletedCount
    }
  }
`;
